/** MI DOMINO - loose DOM accessors for the UI modules carved out of the legacy
 *  client. `$` is getElementById typed as `any` (the app shells always exist; a
 *  missing id throws exactly as the untyped code did), `$$` is querySelectorAll
 *  as a plain array. */
export const $ = (id: string): any => document.getElementById(id);
export const $$ = (sel: string): any[] => Array.from(document.querySelectorAll(sel));
